import lottie from 'lottie-web';

export default class Throbber {
  static instance;

  constructor () {
    if (this.instance) {
      return this.instance;
    }

    this.instance = this;
  }

  wrapperDisplay(show){
    let container = document.getElementById('throbber-container');
    if(show){
      container.style.display = 'block';
    } else {
      container.style.display = 'none';
    }
  }

  show() {
    this.wrapperDisplay(true);
    if (!this.animation) {
      this.animation = lottie.loadAnimation ({
        container: document.getElementById('throbber-container'),
        renderer: 'svg',
        loop: true,
        autoplay: false,
        path: '/throbber.json',
        rendererSettings: {
          id: 'throbber-animation'
        }
      });
    }
    this.animation.play();
  };

  hide() {
    this.wrapperDisplay(false);
    if(this.animation){
      this.animation.stop();
    }
  }
}
